import script from "./GroupsView.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsView.vue?vue&type=script&setup=true&lang=js"

import "./GroupsView.vue?vue&type=style&index=0&id=54a83c6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a83c6c"]])

export default __exports__